export const ACCOUNT_TYPE = {
  MULTI: `Multi`,
  SINGLE: `Single`,
}
